/**
 * Parse a "from" text field into name and email parts.
 * Handles formats like:
 *   - "John Doe <john@example.com>"
 *   - "<john@example.com>"
 *   - "john@example.com"
 */
export const parseEmailAddress = (fromText: string): { name: string; email: string } => {
    const angleMatch = fromText.match(/^(.+?)\s*<(.+?)>$/);
    if (angleMatch) {
        return {
            name: angleMatch[1].replace(/^["']|["']$/g, '').trim(),
            email: angleMatch[2].trim(),
        };
    }

    const bareAngleMatch = fromText.match(/^<(.+?)>$/);
    if (bareAngleMatch) {
        return { name: '', email: bareAngleMatch[1].trim() };
    }

    return { name: '', email: fromText.trim() };
};
